
const getAdvancedFilters = (searchOptions = [], addedByDefault = 'ME') => [
{
  type: 'MULTI_SEARCH',
  name: 'addedBy',
  label: 'Assets',
  additionalOptions: {
    placeholder: 'Search users',
    customPrefix: 'search',
    searchOptions
  },
  filterFacets: [
  { label: 'Added by Me', value: 'ME', selectedDefault: addedByDefault === 'ME' },
  { label: 'Added by Everyone', value: 'ALL', selectedDefault: addedByDefault === 'ALL' }]

},
{
  type: 'DATE_RANGE',
  name: 'dateUploaded',
  label: 'Date Uploaded',
  filterFacets: [
  { label: 'All', value: 'ALL', selectedDefault: true },
  {
    label: 'Date Range',
    value: 'DATE_RANGE',
    showDateRange: true,
    startPlaceholder: 'Select date',
    endPlaceholder: 'Select date'
  }]

},
{
  type: 'CHECKBOX',
  name: 'fileType',
  label: 'Asset Type',
  filterFacets: [
  { label: 'All', value: 'ALL', selectedDefault: true },
  { label: 'Videos', value: 'VIDEO' },
  { label: 'Photos', value: 'IMAGE' },
  { label: 'Audio', value: 'AUDIO' },
  { label: 'Documents', value: 'DOCUMENT' },
  { label: 'Stock', value: 'STOCK' },
  { label: 'Other', value: 'OTHER' }]

},
{
  type: 'RADIO',
  name: 'status',
  label: 'Status',
  filterFacets: [
  { label: 'Active', value: 'ACTIVE', selectedDefault: true },
  { label: 'Archived', value: 'ARCHIVED' }]

}];


export default getAdvancedFilters;